export const prefsSeed = {
    "en": {
        "tb": {
            "ast": "Assist Home",
            "srch": "Search",
            "mB": "My Bot",
            "trnspt": "Transcript"
        },
        "sg": {
            "sA": {
                "lbl": {
                    "ans": "Answers",
                    "wP": "Web Pages",
                    "files": "Files"
                }
            },
            "faq": {
                "lbl": {
                    "faq": "FAQ"
                }
            },
            "dT": {
                "lbl": {
                    "dTN": "Dialog Task",
                    "tmnt": "Terminate",
                    "tmntCfm": "Terminate Dialog Task",
                    "tmntBtn": "Yes, Terminate",
                    "scVsbty": 50
                },
                "tL": {
                    "isE": true,
                    "st": {
                        "isE": true,
                        "msg": "Dialog {{Task}} started"
                    },
                    "end": {
                        "isE": true,
                        "msg": "Dialog {{Task}} ended"
                    }
                },
                "mT": {
                    "isE": true,
                    "ask": {
                        "isE": true,
                        "msg": "Ask Customer"
                    },
                    "tell": {
                        "isE": true,
                        "msg": "Tell Customer"
                    }
                }
            }
        },
        "lout": {
            "pos": "bottom",
            "dfTb": "ast",
            "ord": [
                {
                    "ast": {
                        "isE": true
                    }
                },
                {
                    "srch": {
                        "isE": true
                    }
                },
                {
                    "mB": {
                        "isE": true
                    }
                },
                {
                    "trnspt": {
                        "isE": true
                    }
                }
            ]
        },
        "act": [
            {
                "smt": {
                    "isE": true
                }
            },
            {
                "rst": {
                    "isE": true
                }
            },
            {
                "lV": {
                    "isE": true
                }
            }
        ],
        "grouping" : {
            
        }
    },
    "ar": {
        "tb": {
            "ast": "يساعد",
            "srch": "بحث",
            "mB": "بوتي",
            "trnspt": "النص"
        },
        "sg": {
            "sA": {
                "lbl": {
                    "ans": "إجابات",
                    "wP": "Web Pages",
                    "files": "Files"
                }
            },
            "faq": {
                "lbl": {
                    "faq": "أسئلة"
                }
            },
            "dT": {
                "lbl": {
                    "dTN": "الحوار",
                    "tmnt": "إنهاء",
                    "tmntCfm": "إنهاء مهمة الحوار (العنوان)",
                    "tmntBtn": "نعم، إنهاء (زر)",
                    "scVsbty": 50
                },
                "tL": {
                    "isE": true,
                    "st": {
                        "isE": true,
                        "msg": "بدأ الحوار {{Task}}"
                    },
                    "end": {
                        "isE": true,
                        "msg": "انتهى الحوار {{Task}}"
                    }
                },
                "mT": {
                    "isE": true,
                    "ask": {
                        "isE": true,
                        "msg": "اسأل العميل"
                    },
                    "tell": {
                        "isE": true,
                        "msg": "أخبر العميل"
                    }
                }
            }
        },
        "lout": {
            "pos": "bottom",
            "dfTb": "ast",
            "ord": [
                {
                    "ast": {
                        "isE": true
                    }
                },
                {
                    "srch": {
                        "isE": true
                    }
                },
                {
                    "mB": {
                        "isE": true
                    }
                },
                {
                    "trnspt": {
                        "isE": true
                    }
                }
            ]
        },
        "act": [
            {
                "smt": {
                    "isE": true
                }
            },
            {
                "rst": {
                    "isE": true
                }
            },
            {
                "lV": {
                    "isE": true
                }
            }
        ],
        "grouping" : {
            
        }
    },
    "de": {
        "tb": {
            "ast": "Assistieren",
            "srch": "Suche",
            "mB": "Mein Bot",
            "trnspt": "Transkript"
        },
        "sg": {
            "sA": {
                "lbl": {
                    "ans": "Antworten",
                    "wP": "Web Pages",
                    "files": "Files"
                }
            },
            "faq": {
                "lbl": {
                    "faq": "Fragen"
                }
            },
            "dT": {
                "lbl": {
                    "dTN": "Gespräch",
                    "tmnt": "Beenden",
                    "tmntCfm": "Dialog beenden",
                    "tmntBtn": "Ja, Beenden",
                    "scVsbty": 50
                },
                "tL": {
                    "isE": true,
                    "st": {
                        "isE": true,
                        "msg": "Dialog {{Task}} gestartet"
                    },
                    "end": {
                        "isE": true,
                        "msg": "Dialog {{Task}} beendet"
                    }
                },
                "mT": {
                    "isE": true,
                    "ask": {
                        "isE": true,
                        "msg": "Kunden fragen"
                    },
                    "tell": {
                        "isE": true,
                        "msg": "Kunde informieren"
                    }
                }
            }
        },
        "lout": {
            "pos": "bottom",
            "dfTb": "ast",
            "ord": [
                {
                    "ast": {
                        "isE": true
                    }
                },
                {
                    "srch": {
                        "isE": true
                    }
                },
                {
                    "mB": {
                        "isE": true
                    }
                },
                {
                    "trnspt": {
                        "isE": true
                    }
                }
            ]
        },
        "act": [
            {
                "smt": {
                    "isE": true
                }
            },
            {
                "rst": {
                    "isE": true
                }
            },
            {
                "lV": {
                    "isE": true
                }
            }
        ],
        "grouping" : {
            
        }
    },
    "es": {
        "tb": {
            "ast": "Asistencia",
            "srch": "Buscar",
            "mB": "Mi Bot",
            "trnspt": "Transcrito"
        },
        "sg": {
            "sA": {
                "lbl": {
                    "ans": "Respuestas",
                    "wP": "Web Pages",
                    "files": "Files"
                }
            },
            "faq": {
                "lbl": {
                    "faq": "Preguntas"
                }
            },
            "dT": {
                "lbl": {
                    "dTN": "Diálogo",
                    "tmnt": "Terminar",
                    "tmntCfm": "Finalizar Diálogo",
                    "tmntBtn": "Sí, Finalizar",
                    "scVsbty": 50
                },
                "tL": {
                    "isE": true,
                    "st": {
                        "isE": true,
                        "msg": "Iniciado el diálogo {{Task}}"
                    },
                    "end": {
                        "isE": true,
                        "msg": "Diálogo {{Task}} finalizado"
                    }
                },
                "mT": {
                    "isE": true,
                    "ask": {
                        "isE": true,
                        "msg": "Preguntar al cliente"
                    },
                    "tell": {
                        "isE": true,
                        "msg": "Informar al cliente"
                    }
                }
            }
        },
        "lout": {
            "pos": "bottom",
            "dfTb": "ast",
            "ord": [
                {
                    "ast": {
                        "isE": true
                    }
                },
                {
                    "srch": {
                        "isE": true
                    }
                },
                {
                    "mB": {
                        "isE": true
                    }
                },
                {
                    "trnspt": {
                        "isE": true
                    }
                }
            ]
        },
        "act": [
            {
                "smt": {
                    "isE": true
                }
            },
            {
                "rst": {
                    "isE": true
                }
            },
            {
                "lV": {
                    "isE": true
                }
            }
        ],
        "grouping" : {
            
        }
    },
    "fr": {
        "tb": {
            "ast": "Assistance",
            "srch": "Recherche",
            "mB": "Mon Bot",
            "trnspt": "Transcrit"
        },
        "sg": {
            "sA": {
                "lbl": {
                    "ans": "Réponses",
                    "wP": "Web Pages",
                    "files": "Files"
                }
            },
            "faq": {
                "lbl": {
                    "faq": "Questions"
                }
            },
            "dT": {
                "lbl": {
                    "dTN": "Dialogue",
                    "tmnt": "Terminer",
                    "tmntCfm": "Terminer Dialogue",
                    "tmntBtn": "Oui, Terminer",
                    "scVsbty": 50
                },
                "tL": {
                    "isE": true,
                    "st": {
                        "isE": true,
                        "msg": "Début du dialogue {{Task}}"
                    },
                    "end": {
                        "isE": true,
                        "msg": "Dialogue {{Task}} terminé"
                    }
                },
                "mT": {
                    "isE": true,
                    "ask": {
                        "isE": true,
                        "msg": "Demander au client"
                    },
                    "tell": {
                        "isE": true,
                        "msg": "Informer le client"
                    }
                }
            }
        },
        "lout": {
            "pos": "bottom",
            "dfTb": "ast",
            "ord": [
                {
                    "ast": {
                        "isE": true
                    }
                },
                {
                    "srch": {
                        "isE": true
                    }
                },
                {
                    "mB": {
                        "isE": true
                    }
                },
                {
                    "trnspt": {
                        "isE": true
                    }
                }
            ]
        },
        "act": [
            {
                "smt": {
                    "isE": true
                }
            },
            {
                "rst": {
                    "isE": true
                }
            },
            {
                "lV": {
                    "isE": true
                }
            }
        ],
        "grouping" : {
            
        }
    },
    "it": {
        "tb": {
            "ast": "Assistenza",
            "srch": "Cerca",
            "mB": "Il Mio Bot",
            "trnspt": "Trascrizione"
        },
        "sg": {
            "sA": {
                "lbl": {
                    "ans": "Risposte",
                    "wP": "Web Pages",
                    "files": "Files"
                }
            },
            "faq": {
                "lbl": {
                    "faq": "Domande"
                }
            },
            "dT": {
                "lbl": {
                    "dTN": "Dialogo",
                    "tmnt": "Termina",
                    "tmntCfm": "Termina Dialogo",
                    "tmntBtn": "Sì, Termina",
                    "scVsbty": 50
                },
                "tL": {
                    "isE": true,
                    "st": {
                        "isE": true,
                        "msg": "Inizio del dialogo {{Task}}"
                    },
                    "end": {
                        "isE": true,
                        "msg": "Dialogo {{Task}} terminato"
                    }
                },
                "mT": {
                    "isE": true,
                    "ask": {
                        "isE": true,
                        "msg": "Chiedere al cliente"
                    },
                    "tell": {
                        "isE": true,
                        "msg": "Informare il cliente"
                    }
                }
            }
        },
        "lout": {
            "pos": "bottom",
            "dfTb": "ast",
            "ord": [
                {
                    "ast": {
                        "isE": true
                    }
                },
                {
                    "srch": {
                        "isE": true
                    }
                },
                {
                    "mB": {
                        "isE": true
                    }
                },
                {
                    "trnspt": {
                        "isE": true
                    }
                }
            ]
        },
        "act": [
            {
                "smt": {
                    "isE": true
                }
            },
            {
                "rst": {
                    "isE": true
                }
            },
            {
                "lV": {
                    "isE": true
                }
            }
        ],
        "grouping" : {
            
        }
    },
    "ja": {
        "tb": {
            "ast": "アシストホーム",
            "srch": "検索",
            "mB": "マイボット",
            "trnspt": "トランスクリプト"
        },
        "sg": {
            "sA": {
                "lbl": {
                    "ans": "回答",
                    "wP": "Web Pages",
                    "files": "Files"
                }
            },
            "faq": {
                "lbl": {
                    "faq": "よくある質問"
                }
            },
            "dT": {
                "lbl": {
                    "dTN": "ダイアログタスク",
                    "tmnt": "終了",
                    "tmntCfm": "ダイアログタスクの終了",
                    "tmntBtn": "はい、終了します",
                    "scVsbty": 50
                },
                "tL": {
                    "isE": true,
                    "st": {
                        "isE": true,
                        "msg": "ダイアログ{{Task}}開始"
                    },
                    "end": {
                        "isE": true,
                        "msg": "ダイアログ{{Task}}終了"
                    }
                },
                "mT": {
                    "isE": true,
                    "ask": {
                        "isE": true,
                        "msg": "顧客に尋ねる"
                    },
                    "tell": {
                        "isE": true,
                        "msg": "顧客に伝える"
                    }
                }
            }
        },
        "lout": {
            "pos": "bottom",
            "dfTb": "ast",
            "ord": [
                {
                    "ast": {
                        "isE": true
                    }
                },
                {
                    "srch": {
                        "isE": true
                    }
                },
                {
                    "mB": {
                        "isE": true
                    }
                },
                {
                    "trnspt": {
                        "isE": true
                    }
                }
            ]
        },
        "act": [
            {
                "smt": {
                    "isE": true
                }
            },
            {
                "rst": {
                    "isE": true
                }
            },
            {
                "lV": {
                    "isE": true
                }
            }
        ],
        "grouping" : {
            
        }
    },
    "ko": {
        "tb": {
            "ast": "지원 홈",
            "srch": "검색",
            "mB": "내 봇",
            "trnspt": "대화 기록"
        },
        "sg": {
            "sA": {
                "lbl": {
                    "ans": "답변",
                    "wP": "Web Pages",
                    "files": "Files"
                }
            },
            "faq": {
                "lbl": {
                    "faq": "자주 묻는 질문"
                }
            },
            "dT": {
                "lbl": {
                    "dTN": "대화 작업",
                    "tmnt": "종료",
                    "tmntCfm": "대화 상자 작업 종료",
                    "tmntBtn": "예, 종료합니다",
                    "scVsbty": 50
                },
                "tL": {
                    "isE": true,
                    "st": {
                        "isE": true,
                        "msg": "다이얼로그 {{Task}} 시작됨"
                    },
                    "end": {
                        "isE": true,
                        "msg": "다이얼로그 {{Task}} 종료됨"
                    }
                },
                "mT": {
                    "isE": true,
                    "ask": {
                        "isE": true,
                        "msg": "고객에게 묻다"
                    },
                    "tell": {
                        "isE": true,
                        "msg": "고객에게 알리다"
                    }
                }
            }
        },
        "lout": {
            "pos": "bottom",
            "dfTb": "ast",
            "ord": [
                {
                    "ast": {
                        "isE": true
                    }
                },
                {
                    "srch": {
                        "isE": true
                    }
                },
                {
                    "mB": {
                        "isE": true
                    }
                },
                {
                    "trnspt": {
                        "isE": true
                    }
                }
            ]
        },
        "act": [
            {
                "smt": {
                    "isE": true
                }
            },
            {
                "rst": {
                    "isE": true
                }
            },
            {
                "lV": {
                    "isE": true
                }
            }
        ],
        "grouping" : {
            
        }
    },
    "zh_cn": {
        "tb": {
            "ast": "帮助主页",
            "srch": "搜索",
            "mB": "我的机器人",
            "trnspt": "对话记录"
        },
        "sg": {
            "sA": {
                "lbl": {
                    "ans": "答案",
                    "wP": "Web Pages",
                    "files": "Files"
                }
            },
            "faq": {
                "lbl": {
                    "faq": "常见问题"
                }
            },
            "dT": {
                "lbl": {
                    "dTN": "对话任务",
                    "tmnt": "终止",
                    "tmntCfm": "终止对话任务",
                    "tmntBtn": "是的，完成",
                    "scVsbty": 50
                },
                "tL": {
                    "isE": true,
                    "st": {
                        "isE": true,
                        "msg": "对话{{Task}}已开始"
                    },
                    "end": {
                        "isE": true,
                        "msg": "对话{{Task}}已结束"
                    }
                },
                "mT": {
                    "isE": true,
                    "ask": {
                        "isE": true,
                        "msg": "询问客户"
                    },
                    "tell": {
                        "isE": true,
                        "msg": "告知客户"
                    }
                }
            }
        },
        "lout": {
            "pos": "bottom",
            "dfTb": "ast",
            "ord": [
                {
                    "ast": {
                        "isE": true
                    }
                },
                {
                    "srch": {
                        "isE": true
                    }
                },
                {
                    "mB": {
                        "isE": true
                    }
                },
                {
                    "trnspt": {
                        "isE": true
                    }
                }
            ]
        },
        "act": [
            {
                "smt": {
                    "isE": true
                }
            },
            {
                "rst": {
                    "isE": true
                }
            },
            {
                "lV": {
                    "isE": true
                }
            }
        ],
        "grouping" : {
            
        }
    },
    "hi": {
        "tb": {
            "ast": "मदद होम",
            "srch": "खोज",
            "mB": "मेरा बॉट",
            "trnspt": "प्रतिलिपि"
        },
        "sg": {
            "sA": {
                "lbl": {
                    "ans": "उत्तर",
                    "wP": "वेब पेज",
                    "files": "फाइलें"
                }
            },
            "faq": {
                "lbl": {
                    "faq": "प्रश्न"
                }
            },
            "dT": {
                "lbl": {
                    "dTN": "संवाद",
                    "tmnt": "समाप्त",
                    "tmntCfm": "वार्तालाप कार्य समाप्त करें",
                    "tmntBtn": "हाँ, समाप्त करें",
                    "scVsbty": 50
                },
                "tL": {
                    "isE": true,
                    "st": {
                        "isE": true,
                        "msg": "संवाद {{Task}} शुरू हुआ"
                    },
                    "end": {
                        "isE": true,
                        "msg": "संवाद {{Task}} समाप्त हुआ"
                    }
                },
                "mT": {
                    "isE": true,
                    "ask": {
                        "isE": true,
                        "msg": "ग्राहक से पूछें"
                    },
                    "tell": {
                        "isE": true,
                        "msg": "ग्राहक को बताएं"
                    }
                }
            }
        },
        "lout": {
            "pos": "bottom",
            "dfTb": "ast",
            "ord": [
                {
                    "ast": {
                        "isE": true
                    }
                },
                {
                    "srch": {
                        "isE": true
                    }
                },
                {
                    "mB": {
                        "isE": true
                    }
                },
                {
                    "trnspt": {
                        "isE": true
                    }
                }
            ]
        },
        "act": [
            {
                "smt": {
                    "isE": true
                }
            },
            {
                "rst": {
                    "isE": true
                }
            },
            {
                "lV": {
                    "isE": true
                }
            }
        ],
        "grouping" : {
            
        }
    },
    "te": {
        "tb": {
            "ast": "సహాయం హోమ్",
            "srch": "వెతకండి",
            "mB": "నా బాట్",
            "trnspt": "ప్రతిలిపి"
        },
        "sg": {
            "sA": {
                "lbl": {
                    "ans": "సమాధానాలు",
                    "wP": "వెబ్ పేజీలు",
                    "files": "ఫైళ్ళు"
                }
            },
            "faq": {
                "lbl": {
                    "faq": "ఎఫ్ ఎ క్యూ"
                }
            },
            "dT": {
                "lbl": {
                    "dTN": "సంబాషణ పనిని",
                    "tmnt": "ముగించు",
                    "tmntCfm": "సంబాషణ పనిని ముగించండి",
                    "tmntBtn": "అవును, ముగించు",
                    "scVsbty": 50
                },
                "tL": {
                    "isE": true,
                    "st": {
                        "isE": true,
                        "msg": "సంబాషణ {{Task}} ప్రారంభమైంది"
                    },
                    "end": {
                        "isE": true,
                        "msg": "సంబాషణ {{Task}} ముగిసింది"
                    }
                },
                "mT": {
                    "isE": true,
                    "ask": {
                        "isE": true,
                        "msg": "కస్టమర్‌ను అడగండి"
                    },
                    "tell": {
                        "isE": true,
                        "msg": "కస్టమర్‌కు చెప్పండి"
                    }
                }
            }
        },
        "lout": {
            "pos": "bottom",
            "dfTb": "ast",
            "ord": [
                {
                    "ast": {
                        "isE": true
                    }
                },
                {
                    "srch": {
                        "isE": true
                    }
                },
                {
                    "mB": {
                        "isE": true
                    }
                },
                {
                    "trnspt": {
                        "isE": true
                    }
                }
            ]
        },
        "act": [
            {
                "smt": {
                    "isE": true
                }
            },
            {
                "rst": {
                    "isE": true
                }
            },
            {
                "lV": {
                    "isE": true
                }
            }
        ],
        "grouping" : {
            
        }
    },
    "ta": {
        "tb": {
            "ast": "உதவி முகப்பு",
            "srch": "தேடல்",
            "mB": "என் போர்ட்",
            "trnspt": "மொழிபெயர்ப்பு"
        },
        "sg": {
            "sA": {
                "lbl": {
                    "ans": "பதில்கள்",
                    "wP": "வலைப்பக்கங்கள்",
                    "files": "கோப்புகள்"
                }
            },
            "faq": {
                "lbl": {
                    "faq": "கேள்விகள்"
                }
            },
            "dT": {
                "lbl": {
                    "dTN": "பேச்சு பணி",
                    "tmnt": "முடிக்கவும்",
                    "tmntCfm": "பேச்சு பணி முடிக்கவும்",
                    "tmntBtn": "ஆம், முடிக்கவும்",
                    "scVsbty": 50
                },
                "tL": {
                    "isE": true,
                    "st": {
                        "isE": true,
                        "msg": "உரையாடல் {{Task}} தொடங்கியது"
                    },
                    "end": {
                        "isE": true,
                        "msg": "உரையாடல் {{Task}} முடிந்தது"
                    }
                },
                "mT": {
                    "isE": true,
                    "ask": {
                        "isE": true,
                        "msg": "வாடிக்கையாளர் கேள்வி"
                    },
                    "tell": {
                        "isE": true,
                        "msg": "வாடிக்கையாளருக்கு கூறுங்கள்"
                    }
                }
            }
        },
        "lout": {
            "pos": "bottom",
            "dfTb": "ast",
            "ord": [
                {
                    "ast": {
                        "isE": true
                    }
                },
                {
                    "srch": {
                        "isE": true
                    }
                },
                {
                    "mB": {
                        "isE": true
                    }
                },
                {
                    "trnspt": {
                        "isE": true
                    }
                }
            ]
        },
        "act": [
            {
                "smt": {
                    "isE": true
                }
            },
            {
                "rst": {
                    "isE": true
                }
            },
            {
                "lV": {
                    "isE": true
                }
            }
        ],
        "grouping" : {
            
        }
    },
    "mr": {
        "tb": {
            "ast": "सहाय्य होम",
            "srch": "शोधा",
            "mB": "माझा बॉट",
            "trnspt": "प्रतिलिपी"
        },
        "sg": {
            "sA": {
                "lbl": {
                    "ans": "उत्तर",
                    "wP": "वेब पेज",
                    "files": "फाईल्स"
                }
            },
            "faq": {
                "lbl": {
                    "faq": "प्रश्न"
                }
            },
            "dT": {
                "lbl": {
                    "dTN": "संवाद कार्य",
                    "tmnt": "समाप्त",
                    "tmntCfm": "संवाद कार्य समाप्त",
                    "tmntBtn": "होय, समाप्त",
                    "scVsbty": 50
                },
                "tL": {
                    "isE": true,
                    "st": {
                        "isE": true,
                        "msg": "संवाद {{Task}} सुरू"
                    },
                    "end": {
                        "isE": true,
                        "msg": "संवाद {{Task}} समाप्त"
                    }
                },
                "mT": {
                    "isE": true,
                    "ask": {
                        "isE": true,
                        "msg": "ग्राहकाला विचारा"
                    },
                    "tell": {
                        "isE": true,
                        "msg": "ग्राहकाला सांगा"
                    }
                }
            }
        },
        "lout": {
            "pos": "bottom",
            "dfTb": "ast",
            "ord": [
                {
                    "ast": {
                        "isE": true
                    }
                },
                {
                    "srch": {
                        "isE": true
                    }
                },
                {
                    "mB": {
                        "isE": true
                    }
                },
                {
                    "trnspt": {
                        "isE": true
                    }
                }
            ]
        },
        "act": [
            {
                "smt": {
                    "isE": true
                }
            },
            {
                "rst": {
                    "isE": true
                }
            },
            {
                "lV": {
                    "isE": true
                }
            }
        ],
        "grouping" : {
            
        }
    },
    "as": {
        "tb": {
            "ast": "সহায়ক হোম",
            "srch": "অনুসন্ধান",
            "mB": "মোৰ বট",
            "trnspt": "প্ৰতিলিপি"
        },
        "sg": {
            "sA": {
                "lbl": {
                    "ans": "উত্তৰ",
                    "wP": "ৱেব পৃষ্ঠা",
                    "files": "ফাইলসমূহ"
                }
            },
            "faq": {
                "lbl": {
                    "faq": "প্ৰশ্ন"
                }
            },
            "dT": {
                "lbl": {
                    "dTN": "কথোপকথন টাস্ক",
                    "tmnt": "সমাপ্ত কৰক",
                    "tmntCfm": "কথোপকথন টাস্ক সমাপ্ত কৰক",
                    "tmntBtn": "হয়, সমাপ্ত কৰক",
                    "scVsbty": 50
                },
                "tL": {
                    "isE": true,
                    "st": {
                        "isE": true,
                        "msg": "কথোপকথন {{Task}} আৰম্ভ হৈছে"
                    },
                    "end": {
                        "isE": true,
                        "msg": "কথোপকথন {{Task}} শেষ হৈছে"
                    }
                },
                "mT": {
                    "isE": true,
                    "ask": {
                        "isE": true,
                        "msg": "গ্ৰাহকক সুধক"
                    },
                    "tell": {
                        "isE": true,
                        "msg": "গ্ৰাহকক কওক"
                    }
                }
            }
        },
        "lout": {
            "pos": "bottom",
            "dfTb": "ast",
            "ord": [
                {
                    "ast": {
                        "isE": true
                    }
                },
                {
                    "srch": {
                        "isE": true
                    }
                },
                {
                    "mB": {
                        "isE": true
                    }
                },
                {
                    "trnspt": {
                        "isE": true
                    }
                }
            ]
        },
        "act": [
            {
                "smt": {
                    "isE": true
                }
            },
            {
                "rst": {
                    "isE": true
                }
            },
            {
                "lV": {
                    "isE": true
                }
            }
        ],
        "grouping" : {
            
        }
    },
    "bn": {
        "tb": {
            "ast": "সহায়ক হোম",
            "srch": "অনুসন্ধান",
            "mB": "আমার বট",
            "trnspt": "ট্রান্সক্রিপ্ট"
        },
        "sg": {
            "sA": {
                "lbl": {
                    "ans": "উত্তর",
                    "wP": "ওয়েব পেজ",
                    "files": "ফাইলগুলি"
                }
            },
            "faq": {
                "lbl": {
                    "faq": "FAQ"
                }
            },
            "dT": {
                "lbl": {
                    "dTN": "সংলাপ কাজ",
                    "tmnt": "সমাপ্তি",
                    "tmntCfm": "সংলাপ কাজ সমাপ্তি",
                    "tmntBtn": "হ্যাঁ, সমাপ্তি",
                    "scVsbty": 50
                },
                "tL": {
                    "isE": true,
                    "st": {
                        "isE": true,
                        "msg": "সংলাপ {{Task}} শুরু"
                    },
                    "end": {
                        "isE": true,
                        "msg": "সংলাপ {{Task}} শেষ"
                    }
                },
                "mT": {
                    "isE": true,
                    "ask": {
                        "isE": true,
                        "msg": "গ্রাহককে প্রশ্ন করুন"
                    },
                    "tell": {
                        "isE": true,
                        "msg": "গ্রাহককে জানান"
                    }
                }
            }
        },
        "lout": {
            "pos": "bottom",
            "dfTb": "ast",
            "ord": [
                {
                    "ast": {
                        "isE": true
                    }
                },
                {
                    "srch": {
                        "isE": true
                    }
                },
                {
                    "mB": {
                        "isE": true
                    }
                },
                {
                    "trnspt": {
                        "isE": true
                    }
                }
            ]
        },
        "act": [
            {
                "smt": {
                    "isE": true
                }
            },
            {
                "rst": {
                    "isE": true
                }
            },
            {
                "lV": {
                    "isE": true
                }
            }
        ],
        "grouping" : {
            
        }
    },
    "gu": {
        "tb": {
            "ast": "મદદ હોમ",
            "srch": "શોધો",
            "mB": "મારો બોટ",
            "trnspt": "ટ્રાન્સક્રિપ્ટ"
        },
        "sg": {
            "sA": {
                "lbl": {
                    "ans": "જવાબો",
                    "wP": "વેબ પેજ",
                    "files": "ફાઇલો"
                }
            },
            "faq": {
                "lbl": {
                    "faq": "પ્રશ્નો"
                }
            },
            "dT": {
                "lbl": {
                    "dTN": "સંવાદ કાર્ય",
                    "tmnt": "સમાપ્ત",
                    "tmntCfm": "સંવાદ કાર્ય સમાપ્ત કરો",
                    "tmntBtn": "હા, સમાપ્ત કરો",
                    "scVsbty": 50
                },
                "tL": {
                    "isE": true,
                    "st": {
                        "isE": true,
                        "msg": "સંવાદ {{Task}} શરૂ થઈ",
                    },
                    "end": {
                        "isE": true,
                        "msg": "સંવાદ {{Task}} પૂર્ણ થયું",
                    }
                },
                "mT": {
                    "isE": true,
                    "ask": {
                        "isE": true,
                        "msg": "ગ્રાહકને પૂછો",
                    },
                    "tell": {
                        "isE": true,
                        "msg": "ગ્રાહકને કહો",
                    }
                }
            }
        },
        "lout": {
            "pos": "bottom",
            "dfTb": "ast",
            "ord": [
                {
                    "ast": {
                        "isE": true,
                    }
                },
                {
                    "srch": {
                        "isE": true,
                    }
                },
                {
                    "mB": {
                        "isE": true,
                    }
                },
                {
                    "trnspt": {
                        "isE": true,
                    }
                }
            ]
        },
        "act": [
            {
                "smt": {
                    "isE": true,
                }
            },
            {
                "rst": {
                    "isE": true,
                }
            },
            {
                "lV": {
                    "isE": true,
                }
            }
        ],
        "grouping" : {
            
        }
    },
    "kn": {
        "tb": {
            "ast": "ಸಹಾಯ ಹೋಮ್",
            "srch": "ಹುಡುಕಿ",
            "mB": "ನನ್ನ ಬಾಟ್",
            "trnspt": "ಪ್ರತಿಪಾದನೆ"
        },
        "sg": {
            "sA": {
                "lbl": {
                    "ans": "ಉತ್ತರಗಳು",
                    "wP": "ವೆಬ್ ಪುಟಗಳು",
                    "files": "ಫೈಲ್‌ಗಳು"
                }
            },
            "faq": {
                "lbl": {
                    "faq": "ಪ್ರಶ್ನೆಗಳು"
                }
            },
            "dT": {
                "lbl": {
                    "dTN": "ಸಂವಾದ ಕಾರ್ಯ",
                    "tmnt": "ಅಂತಿಮ",
                    "tmntCfm": "ಸಂವಾದ ಕಾರ್ಯ ಅಂತಿಮ",
                    "tmntBtn": "ಹೌದು, ಅಂತಿಮ",
                    "scVsbty": 50
                },
                "tL": {
                    "isE": true,
                    "st": {
                        "isE": true,
                        "msg": "ಸಂವಾದ {{Task}} ಆರಂಭ"
                    },
                    "end": {
                        "isE": true,
                        "msg": "ಸಂವಾದ {{Task}} ಅಂತಿಮಗೊಂಡಿತು"
                    }
                },
                "mT": {
                    "isE": true,
                    "ask": {
                        "isE": true,
                        "msg": "ಗ್ರಾಹಕರನ್ನು ಕೇಳಿ"
                    },
                    "tell": {
                        "isE": true,
                        "msg": "ಗ್ರಾಹಕರಿಗೆ ತಿಳಿಸಿ"
                    }
                }
            }
        },
        "lout": {
            "pos": "bottom",
            "dfTb": "ast",
            "ord": [
                {
                    "ast": {
                        "isE": true
                    }
                },
                {
                    "srch": {
                        "isE": true
                    }
                },
                {
                    "mB": {
                        "isE": true
                    }
                },
                {
                    "trnspt": {
                        "isE": true
                    }
                }
            ]
        },
        "act": [
            {
                "smt": {
                    "isE": true
                }
            },
            {
                "rst": {
                    "isE": true
                }
            },
            {
                "lV": {
                    "isE": true
                }
            }
        ],
        "grouping" : {
            
        }
    },
    "ml": {
        "tb": {
            "ast": "സഹായം ഹോം",
            "srch": "തിരയുക",
            "mB": "ನನ್ನ ಬೋಟ್",
            "trnspt": "പകര്‍പ്പ്"
        },
        "sg": {
            "sA": {
                "lbl": {
                    "ans": "ഉത്തരം",
                    "wP": "വെബ് പേജ്",
                    "files": "ഫയലുകൾ"
                }
            },
            "faq": {
                "lbl": {
                    "faq": "ചോദ്യങ്ങൾ"
                }
            },
            "dT": {
                "lbl": {
                    "dTN": "സംവാദ ടാസ്‌ക്",
                    "tmnt": "അവസാനിക്കുക",
                    "tmntCfm": "സംവാദം അവസാനിപ്പിക്കുക",
                    "tmntBtn": "അതെ, അവസാനിക്കുക",
                    "scVsbty": 50
                },
                "tL": {
                    "isE": true,
                    "st": {
                        "isE": true,
                        "msg": "സംവാദം {{Task}} ആരംഭിച്ചു"
                    },
                    "end": {
                        "isE": true,
                        "msg": "സംവാദം {{Task}} അവസാനിച്ചു"
                    }
                },
                "mT": {
                    "isE": true,
                    "ask": {
                        "isE": true,
                        "msg": "ഗ്രാഹകനെ ചോദിക്കുക"
                    },
                    "tell": {
                        "isE": true,
                        "msg": "ഗ്രാഹകനെ പറയുക"
                    }
                }
            }
        },
        "lout": {
            "pos": "bottom",
            "dfTb": "ast",
            "ord": [
                {
                    "ast": {
                        "isE": true
                    }
                },
                {
                    "srch": {
                        "isE": true
                    }
                },
                {
                    "mB": {
                        "isE": true
                    }
                },
                {
                    "trnspt": {
                        "isE": true
                    }
                }
            ]
        },
        "act": [
            {
                "smt": {
                    "isE": true
                }
            },
            {
                "rst": {
                    "isE": true
                }
            },
            {
                "lV": {
                    "isE": true
                }
            }
        ],
        "grouping" : {
            
        }
    },
    "ne": {
        "tb": {
            "ast": "सहायता होम",
            "srch": "खोज",
            "mB": "मेरो बोट",
            "trnspt": "प्रतिलिपि"
        },
        "sg": {
            "sA": {
                "lbl": {
                    "ans": "उत्तरहरू",
                    "wP": "वेब पृष्ठहरू",
                    "files": "फाइलहरू"
                }
            },
            "faq": {
                "lbl": {
                    "faq": "प्रश्नहरू"
                }
            },
            "dT": {
                "lbl": {
                    "dTN": "संवाद",
                    "tmnt": "समाप्त",
                    "tmntCfm": "संवाद कार्य समाप्त गर्नुहोस्",
                    "tmntBtn": "हो, समाप्त गर्नुहोस्",
                    "scVsbty": 50
                },
                "tL": {
                    "isE": true,
                    "st": {
                        "isE": true,
                        "msg": "संवाद {{Task}} सुरु भयो"
                    },
                    "end": {
                        "isE": true,
                        "msg": "संवाद {{Task}} समाप्त भयो"
                    }
                },
                "mT": {
                    "isE": true,
                    "ask": {
                        "isE": true,
                        "msg": "ग्राहकलाई सोध्नुहोस्"
                    },
                    "tell": {
                        "isE": true,
                        "msg": "ग्राहकलाई भन्नुहोस्"
                    }
                }
            }
        },
        "lout": {
            "pos": "bottom",
            "dfTb": "ast",
            "ord": [
                {
                    "ast": {
                        "isE": true
                    }
                },
                {
                    "srch": {
                        "isE": true
                    }
                },
                {
                    "mB": {
                        "isE": true
                    }
                },
                {
                    "trnspt": {
                        "isE": true
                    }
                }
            ]
        },
        "act": [
            {
                "smt": {
                    "isE": true
                }
            },
            {
                "rst": {
                    "isE": true
                }
            },
            {
                "lV": {
                    "isE": true
                }
            }
        ],
        "grouping" : {
            
        }
    },
    "or": {
        "tb": {
            "ast": "ସହାଯ୍ୟ ହୋମ୍",
            "srch": "ଖୋଜନ୍ତୁ",
            "mB": "ମୋର ବଟ୍",
            "trnspt": "ଲେଖା"
        },
        "sg": {
            "sA": {
                "lbl": {
                    "ans": "ଉତ୍ତର",
                    "wP": "ଏବ ପୃଷ୍ଠା",
                    "files": "ଫାଇଲ୍"
                }
            },
            "faq": {
                "lbl": {
                    "faq": "ପ୍ରଶ୍ନ"
                }
            },
            "dT": {
                "lbl": {
                    "dTN": "ସଂବାଦ କାମ୍",
                    "tmnt": "ସମାପ୍ତ",
                    "tmntCfm": "ସଂବାଦ କାମ୍ ସମାପ୍ତ",
                    "tmntBtn": "ହଁ, ସମାପ୍ତ",
                    "scVsbty": 50
                },
                "tL": {
                    "isE": true,
                    "st": {
                        "isE": true,
                        "msg": "ସଂବାଦ {{Task}} ଆରମ୍ଭ"
                    },
                    "end": {
                        "isE": true,
                        "msg": "ସଂବାଦ {{Task}} ସମାପ୍ତ"
                    }
                },
                "mT": {
                    "isE": true,
                    "ask": {
                        "isE": true,
                        "msg": "ଗ୍ରାହକକୁ ପଚାରନ୍ତୁ"
                    },
                    "tell": {
                        "isE": true,
                        "msg": "ଗ୍ରାହକକୁ କୁହନ୍ତୁ"
                    }
                }
            }
        },
        "lout": {
            "pos": "bottom",
            "dfTb": "ast",
            "ord": [
                {
                    "ast": {
                        "isE": true
                    }
                },
                {
                    "srch": {
                        "isE": true
                    }
                },
                {
                    "mB": {
                        "isE": true
                    }
                },
                {
                    "trnspt": {
                        "isE": true
                    }
                }
            ]
        },
        "act": [
            {
                "smt": {
                    "isE": true
                }
            },
            {
                "rst": {
                    "isE": true
                }
            },
            {
                "lV": {
                    "isE": true
                }
            }
        ],
        "grouping" : {
            
        }
    },
    "pa": {
        "tb": {
            "ast": "ਸਹਾਇਤਾ ਹੋਮ",
            "srch": "ਖੋਜ",
            "mB": "ਮੇਰਾ ਬੋਟ",
            "trnspt": "ਟ੍ਰਾਂਸਕ੍ਰਿਪਟ"
        },
        "sg": {
            "sA": {
                "lbl": {
                    "ans": "ਉੱਤਰ",
                    "wP": "ਵੈੱਬ ਪੇਜ",
                    "files": "ਫਾਈਲਾਂ"
                }
            },
            "faq": {
                "lbl": {
                    "faq": "ਸਵਾਲ"
                }
            },
            "dT": {
                "lbl": {
                    "dTN": "ਗੱਲਬਾਤ ਕੰਮ",
                    "tmnt": "ਸਮਾਪਤ",
                    "tmntCfm": "ਗੱਲਬਾਤ ਕੰਮ ਸਮਾਪਤ",
                    "tmntBtn": "ਹਾਂ, ਸਮਾਪਤ",
                    "scVsbty": 50
                },
                "tL": {
                    "isE": true,
                    "st": {
                        "isE": true,
                        "msg": "ਗੱਲਬਾਤ {{Task}} ਸ਼ੁਰੂ ਹੋਈ"
                    },
                    "end": {
                        "isE": true,
                        "msg": "ਗੱਲਬਾਤ {{Task}} ਸਮਾਪਤ ਹੋਈ"
                    }
                },
                "mT": {
                    "isE": true,
                    "ask": {
                        "isE": true,
                        "msg": "ਗਾਹਕ ਨੂੰ ਪੁੱਛੋ"
                    },
                    "tell": {
                        "isE": true,
                        "msg": "ਗਾਹਕ ਨੂੰ ਦੱਸੋ"
                    }
                }
            }
        },
        "lout": {
            "pos": "bottom",
            "dfTb": "ast",
            "ord": [
                {
                    "ast": {
                        "isE": true
                    }
                },
                {
                    "srch": {
                        "isE": true
                    }
                },
                {
                    "mB": {
                        "isE": true
                    }
                },
                {
                    "trnspt": {
                        "isE": true
                    }
                }
            ]
        },
        "act": [
            {
                "smt": {
                    "isE": true
                }
            },
            {
                "rst": {
                    "isE": true
                }
            },
            {
                "lV": {
                    "isE": true
                }
            }
        ],
        "grouping" : {
            
        }
    },
    "nl": {
        "tb": {
            "ast": "Hulp Thuis",
            "srch": "Zoeken",
            "mB": "Mijn Bot",
            "trnspt": "Transcript"
        },
        "sg": {
            "sA": {
                "lbl": {
                    "ans": "Antwoorden",
                    "wP": "Webpagina's",
                    "files": "Bestanden"
                }
            },
            "faq": {
                "lbl": {
                    "faq": "Vragen"
                }
            },
            "dT": {
                "lbl": {
                    "dTN": "Dialoog Taak",
                    "tmnt": "Beëindigen",
                    "tmntCfm": "Dialoog Taak Beëindigen",
                    "tmntBtn": "Ja, beëindigen",
                    "scVsbty": 50
                },
                "tL": {
                    "isE": true,
                    "st": {
                        "isE": true,
                        "msg": "Dialoog {{Task}} gestart"
                    },
                    "end": {
                        "isE": true,
                        "msg": "Dialoog {{Task}} beëindigd"
                    }
                },
                "mT": {
                    "isE": true,
                    "ask": {
                        "isE": true,
                        "msg": "Vraag Klant"
                    },
                    "tell": {
                        "isE": true,
                        "msg": "Vertel Klant"
                    }
                }
            }
        },
        "lout": {
            "pos": "bottom",
            "dfTb": "ast",
            "ord": [
                {
                    "ast": {
                        "isE": true
                    }
                },
                {
                    "srch": {
                        "isE": true
                    }
                },
                {
                    "mB": {
                        "isE": true
                    }
                },
                {
                    "trnspt": {
                        "isE": true
                    }
                }
            ]
        },
        "act": [
            {
                "smt": {
                    "isE": true
                }
            },
            {
                "rst": {
                    "isE": true
                }
            },
            {
                "lV": {
                    "isE": true
                }
            }
        ],
        "grouping" : {
            
        }
    },
    "he": {
        "tb": {
            "ast": "סיוע",
            "srch": "חיפוש",
            "mB": "הבוט שלי",
            "trnspt": "תמליל"
        },
        "sg": {
            "sA": {
                "lbl": {
                    "ans": "תשובות",
                    "wP": "שאלות נפוצות",
                    "files": "files"
                }
            },
            "faq": {
                "lbl": {
                    "faq": "שאלות נפוצות"
                }
            },
            "dT": {
                "lbl": {
                    "dTN": "דיאלוג",
                    "tmnt": "סיים",
                    "tmntCfm": "סיים משימת דיאלוג",
                    "tmntBtn": "כן, סיים",
                    "scVsbty": 50
                },
                "tL": {
                    "isE": true,
                    "st": {
                        "isE": true,
                        "msg": "דיאלוג <Task> התחיל"
                    },
                    "end": {
                        "isE": true,
                        "msg": "דיאלוג <Task> הסתיים"
                    }
                },
                "mT": {
                    "isE": true,
                    "ask": {
                        "isE": true,
                        "msg": "שאל את הלקוח"
                    },
                    "tell": {
                        "isE": true,
                        "msg": "אמור ללקוח"
                    }
                }
            }
        },
        "lout": {
            "pos": "bottom",
            "dfTb": "ast",
            "ord": [
                {
                    "ast": {
                        "isE": true
                    }
                },
                {
                    "srch": {
                        "isE": true
                    }
                },
                {
                    "mB": {
                        "isE": true
                    }
                },
                {
                    "trnspt": {
                        "isE": true
                    }
                }
            ]
        },
        "act": [
            {
                "smt": {
                    "isE": true
                }
            },
            {
                "rst": {
                    "isE": true
                }
            },
            {
                "lV": {
                    "isE": true
                }
            }
        ],
        "grouping" : {
            
        }
    },
    "zh_tw": {
        "tb": {
            "ast": "協助",
            "srch": "搜尋",
            "mB": "我的機器人",
            "trnspt": "逐字稿"
        },
        "sg": {
            "sA": {
                "lbl": {
                    "ans": "答案",
                    "wP": "web page",
                    "files": "files"
                }
            },
            "faq": {
                "lbl": {
                    "faq": "常見問題"
                }
            },
            "dT": {
                "lbl": {
                    "dTN": "對話",
                    "tmnt": "終止",
                    "tmntCfm": "終止對話任務",
                    "tmntBtn": "是，終止",
                    "scVsbty": 50
                },
                "tL": {
                    "isE": true,
                    "st": {
                        "isE": true,
                        "msg": "對話 <Task> 已開始"
                    },
                    "end": {
                        "isE": true,
                        "msg": "對話 <Task> 結束"
                    }
                },
                "mT": {
                    "isE": true,
                    "ask": {
                        "isE": true,
                        "msg": "問顧客"
                    },
                    "tell": {
                        "isE": true,
                        "msg": "告訴顧客"
                    }
                }
            }
        },
        "lout": {
            "pos": "bottom",
            "dfTb": "ast",
            "ord": [
                {
                    "ast": {
                        "isE": true
                    }
                },
                {
                    "srch": {
                        "isE": true
                    }
                },
                {
                    "mB": {
                        "isE": true
                    }
                },
                {
                    "trnspt": {
                        "isE": true
                    }
                }
            ]
        },
        "act": [
            {
                "smt": {
                    "isE": true
                }
            },
            {
                "rst": {
                    "isE": true
                }
            },
            {
                "lV": {
                    "isE": true
                }
            }
        ],
        "grouping" : {
            
        }
    },
    "pt": {
        "tb": {
            "ast": "Assistência",
            "srch": "Buscar",
            "mB": "Meu Bot",
            "trnspt": "Transcrição"
        },
        "sg": {
            "sA": {
                "lbl": {
                    "ans": "Respostas",
                    "wP": "web page",
                    "files": "files"
                }
            },
            "faq": {
                "lbl": {
                    "faq": "Perguntas"
                }
            },
            "dT": {
                "lbl": {
                    "dTN": "Diálogo",
                    "tmnt": "Encerrar",
                    "tmntCfm": "Encerrar Tarefa de Diálogo",
                    "tmntBtn": "Sim, Encerrar",
                    "scVsbty": 50
                },
                "tL": {
                    "isE": true,
                    "st": {
                        "isE": true,
                        "msg": "Diálogo <Task> iniciado"
                    },
                    "end": {
                        "isE": true,
                        "msg": "Diálogo <Task> finalizado"
                    }
                },
                "mT": {
                    "isE": true,
                    "ask": {
                        "isE": true,
                        "msg": "Perguntar ao Cliente"
                    },
                    "tell": {
                        "isE": true,
                        "msg": "Diga ao Cliente"
                    }
                }
            }
        },
        "lout": {
            "pos": "bottom",
            "dfTb": "ast",
            "ord": [
                {
                    "ast": {
                        "isE": true
                    }
                },
                {
                    "srch": {
                        "isE": true
                    }
                },
                {
                    "mB": {
                        "isE": true
                    }
                },
                {
                    "trnspt": {
                        "isE": true
                    }
                }
            ]
        },
        "act": [
            {
                "smt": {
                    "isE": true
                }
            },
            {
                "rst": {
                    "isE": true
                }
            },
            {
                "lV": {
                    "isE": true
                }
            }
        ],
        "grouping" : {
            
        }
    },
    "id": {
        "tb": {
            "ast": "Bantuan",
            "srch": "Cari",
            "mB": "Bot Saya",
            "trnspt": "Transkrip"
        },
        "sg": {
            "sA": {
                "lbl": {
                    "ans": "Jawaban",
                    "wP": "web page",
                    "files": "files"
                }
            },
            "faq": {
                "lbl": {
                    "faq": "Tanya Jawab"
                }
            },
            "dT": {
                "lbl": {
                    "dTN": "Dialog",
                    "tmnt": "Hentikan",
                    "tmntCfm": "Hentikan Tugas Dialog",
                    "tmntBtn": "Ya, Hentikan",
                    "scVsbty": 50
                },
                "tL": {
                    "isE": true,
                    "st": {
                        "isE": true,
                        "msg": "Dialog <Task> dimulai"
                    },
                    "end": {
                        "isE": true,
                        "msg": "Dialog <Task> selesai"
                    }
                },
                "mT": {
                    "isE": true,
                    "ask": {
                        "isE": true,
                        "msg": "Tanya Pelanggan"
                    },
                    "tell": {
                        "isE": true,
                        "msg": "Beritahu Pelanggan"
                    }
                }
            }
        },
        "lout": {
            "pos": "bottom",
            "dfTb": "ast",
            "ord": [
                {
                    "ast": {
                        "isE": true
                    }
                },
                {
                    "srch": {
                        "isE": true
                    }
                },
                {
                    "mB": {
                        "isE": true
                    }
                },
                {
                    "trnspt": {
                        "isE": true
                    }
                }
            ]
        },
        "act": [
            {
                "smt": {
                    "isE": true
                }
            },
            {
                "rst": {
                    "isE": true
                }
            },
            {
                "lV": {
                    "isE": true
                }
            }
        ],
        "grouping" : {
            
        }
    },
    "ru": {
        "tb": {
            "ast": "Помощь",
            "srch": "Поиск",
            "mB": "Мой Бот",
            "trnspt": "Транскрипт"
        },
        "sg": {
            "sA": {
                "lbl": {
                    "ans": "Ответы",
                    "wP": "web page",
                    "files": "files"
                }
            },
            "faq": {
                "lbl": {
                    "faq": "ЧАВО"
                }
            },
            "dT": {
                "lbl": {
                    "dTN": "Диалог",
                    "tmnt": "Завершить",
                    "tmntCfm": "Завершить задачу диалога",
                    "tmntBtn": "Да, завершить",
                    "scVsbty": 50
                },
                "tL": {
                    "isE": true,
                    "st": {
                        "isE": true,
                        "msg": "Диалог <Task> начат"
                    },
                    "end": {
                        "isE": true,
                        "msg": "Диалог <Task> завершён"
                    }
                },
                "mT": {
                    "isE": true,
                    "ask": {
                        "isE": true,
                        "msg": "Спросить клиента"
                    },
                    "tell": {
                        "isE": true,
                        "msg": "Сообщить клиенту"
                    }
                }
            }
        },
        "lout": {
            "pos": "bottom",
            "dfTb": "ast",
            "ord": [
                {
                    "ast": {
                        "isE": true
                    }
                },
                {
                    "srch": {
                        "isE": true
                    }
                },
                {
                    "mB": {
                        "isE": true
                    }
                },
                {
                    "trnspt": {
                        "isE": true
                    }
                }
            ]
        },
        "act": [
            {
                "smt": {
                    "isE": true
                }
            },
            {
                "rst": {
                    "isE": true
                }
            },
            {
                "lV": {
                    "isE": true
                }
            }
        ],
        "grouping" : {
            
        }
    },
    "tr": {
        "tb": {
            "ast": "Yardım",
            "srch": "Ara",
            "mB": "Benim Bot",
            "trnspt": "Transkript"
        },
        "sg": {
            "sA": {
                "lbl": {
                    "ans": "Cevaplar",
                    "wP": "web page",
                    "files": "files"
                }
            },
            "faq": {
                "lbl": {
                    "faq": "SSS"
                }
            },
            "dT": {
                "lbl": {
                    "dTN": "Diyalog",
                    "tmnt": "Sonlandırmak",
                    "tmntCfm": "Diyalog Görevini Sonlandır",
                    "tmntBtn": "Evet, sonlandır",
                    "scVsbty": 50
                },
                "tL": {
                    "isE": true,
                    "st": {
                        "isE": true,
                        "msg": "Diyalog <Task> başladı"
                    },
                    "end": {
                        "isE": true,
                        "msg": "Diyalog <Task> bitti"
                    }
                },
                "mT": {
                    "isE": true,
                    "ask": {
                        "isE": true,
                        "msg": "Müşteriye sor"
                    },
                    "tell": {
                        "isE": true,
                        "msg": "Müşteriye söyle"
                    }
                }
            }
        },
        "lout": {
            "pos": "bottom",
            "dfTb": "ast",
            "ord": [
                {
                    "ast": {
                        "isE": true
                    }
                },
                {
                    "srch": {
                        "isE": true
                    }
                },
                {
                    "mB": {
                        "isE": true
                    }
                },
                {
                    "trnspt": {
                        "isE": true
                    }
                }
            ]
        },
        "act": [
            {
                "smt": {
                    "isE": true
                }
            },
            {
                "rst": {
                    "isE": true
                }
            },
            {
                "lV": {
                    "isE": true
                }
            }
        ],
        "grouping" : {
            
        }
    },
    "vi": {
        "tb": {
            "ast": "Trợ giúp",
            "srch": "Tìm kiếm",
            "mB": "Bot của tôi",
            "trnspt": "Biên bản"
        },
        "sg": {
            "sA": {
                "lbl": {
                    "ans": "Câu trả lời",
                    "wP": "web page",
                    "files": "files"
                }
            },
            "faq": {
                "lbl": {
                    "faq": "Câu hỏi thường gặp"
                }
            },
            "dT": {
                "lbl": {
                    "dTN": "Đối thoại",
                    "tmnt": "Kết thúc",
                    "tmntCfm": "Kết thúc nhiệm vụ hội thoại",
                    "tmntBtn": "Có, kết thúc",
                    "scVsbty": 50
                },
                "tL": {
                    "isE": true,
                    "st": {
                        "isE": true,
                        "msg": "Đối thoại <Task> bắt đầu"
                    },
                    "end": {
                        "isE": true,
                        "msg": "Đối thoại <Task> kết thúc"
                    }
                },
                "mT": {
                    "isE": true,
                    "ask": {
                        "isE": true,
                        "msg": "Hỏi khách hàng"
                    },
                    "tell": {
                        "isE": true,
                        "msg": "Nói với khách hàng"
                    }
                }
            }
        },
        "lout": {
            "pos": "bottom",
            "dfTb": "ast",
            "ord": [
                {
                    "ast": {
                        "isE": true
                    }
                },
                {
                    "srch": {
                        "isE": true
                    }
                },
                {
                    "mB": {
                        "isE": true
                    }
                },
                {
                    "trnspt": {
                        "isE": true
                    }
                }
            ]
        },
        "act": [
            {
                "smt": {
                    "isE": true
                }
            },
            {
                "rst": {
                    "isE": true
                }
            },
            {
                "lV": {
                    "isE": true
                }
            }
        ],
        "grouping" : {
            
        }
    },
    "pl": {
        "tb": {
            "ast": "Pomoc",
            "srch": "Szukaj",
            "mB": "Mój Bot",
            "trnspt": "Transkrypcja"
        },
        "sg": {
            "sA": {
                "lbl": {
                    "ans": "Odpowiedzi",
                    "wP": "web page",
                    "files": "files"
                }
            },
            "faq": {
                "lbl": {
                    "faq": "FAQ"
                }
            },
            "dT": {
                "lbl": {
                    "dTN": "Dialog",
                    "tmnt": "Zakończyć",
                    "tmntCfm": "Zakończ zadanie dialogu",
                    "tmntBtn": "Tak, zakończ",
                    "scVsbty": 50
                },
                "tL": {
                    "isE": true,
                    "st": {
                        "isE": true,
                        "msg": "Dialog <Task> rozpoczęty"
                    },
                    "end": {
                        "isE": true,
                        "msg": "Dialog <Task> zakończony"
                    }
                },
                "mT": {
                    "isE": true,
                    "ask": {
                        "isE": true,
                        "msg": "Zapytaj klienta"
                    },
                    "tell": {
                        "isE": true,
                        "msg": "Powiedz klientowi"
                    }
                }
            }
        },
        "lout": {
            "pos": "bottom",
            "dfTb": "ast",
            "ord": [
                {
                    "ast": {
                        "isE": true
                    }
                },
                {
                    "srch": {
                        "isE": true
                    }
                },
                {
                    "mB": {
                        "isE": true
                    }
                },
                {
                    "trnspt": {
                        "isE": true
                    }
                }
            ]
        },
        "act": [
            {
                "smt": {
                    "isE": true
                }
            },
            {
                "rst": {
                    "isE": true
                }
            },
            {
                "lV": {
                    "isE": true
                }
            }
        ],
        "grouping" : {
            
        }
    },
    "fa": {
        "tb": {
            "ast": "کمک",
            "srch": "جستجو",
            "mB": "ربات من",
            "trnspt": "رونویسی"
        },
        "sg": {
            "sA": {
                "lbl": {
                    "ans": "پاسخ‌ها",
                    "wP": "web page",
                    "files": "files"
                }
            },
            "faq": {
                "lbl": {
                    "faq": "پرسش‌ها"
                }
            },
            "dT": {
                "lbl": {
                    "dTN": "دیالوگ",
                    "tmnt": "پایان دادن",
                    "tmntCfm": "پایان دادن به وظیفه دیالوگ",
                    "tmntBtn": "بله، پایان بدهید",
                    "scVsbty": 50
                },
                "tL": {
                    "isE": true,
                    "st": {
                        "isE": true,
                        "msg": "دیالوگ <Task> شروع شد"
                    },
                    "end": {
                        "isE": true,
                        "msg": "دیالوگ <Task> تمام شد"
                    }
                },
                "mT": {
                    "isE": true,
                    "ask": {
                        "isE": true,
                        "msg": "از مشتری بپرسید"
                    },
                    "tell": {
                        "isE": true,
                        "msg": "به مشتری بگویید"
                    }
                }
            }
        },
        "lout": {
            "pos": "bottom",
            "dfTb": "ast",
            "ord": [
                {
                    "ast": {
                        "isE": true
                    }
                },
                {
                    "srch": {
                        "isE": true
                    }
                },
                {
                    "mB": {
                        "isE": true
                    }
                },
                {
                    "trnspt": {
                        "isE": true
                    }
                }
            ]
        },
        "act": [
            {
                "smt": {
                    "isE": true
                }
            },
            {
                "rst": {
                    "isE": true
                }
            },
            {
                "lV": {
                    "isE": true
                }
            }
        ],
        "grouping" : {
            
        }
    },
    "ur": {
        "tb": {
            "ast": "مدد",
            "srch": "تلاش",
            "mB": "میرا بوٹ",
            "trnspt": "نقل"
        },
        "sg": {
            "sA": {
                "lbl": {
                    "ans": "جوابات",
                    "wP": "web page",
                    "files": "files"
                }
            },
            "faq": {
                "lbl": {
                    "faq": "عمومی سوالات"
                }
            },
            "dT": {
                "lbl": {
                    "dTN": "مکالمہ",
                    "tmnt": "ختم کریں",
                    "tmntCfm": "مکالمہ کام ختم کریں",
                    "tmntBtn": "جی ہاں، ختم کریں",
                    "scVsbty": 50
                },
                "tL": {
                    "isE": true,
                    "st": {
                        "isE": true,
                        "msg": "مکالمہ <Task> شروع ہوا"
                    },
                    "end": {
                        "isE": true,
                        "msg": "مکالمہ <Task> ختم ہوا"
                    }
                },
                "mT": {
                    "isE": true,
                    "ask": {
                        "isE": true,
                        "msg": "صارف سے پوچھیں"
                    },
                    "tell": {
                        "isE": true,
                        "msg": "صارف کو بتائیں"
                    }
                }
            }
        },
        "lout": {
            "pos": "bottom",
            "dfTb": "ast",
            "ord": [
                {
                    "ast": {
                        "isE": true
                    }
                },
                {
                    "srch": {
                        "isE": true
                    }
                },
                {
                    "mB": {
                        "isE": true
                    }
                },
                {
                    "trnspt": {
                        "isE": true
                    }
                }
            ]
        },
        "act": [
            {
                "smt": {
                    "isE": true
                }
            },
            {
                "rst": {
                    "isE": true
                }
            },
            {
                "lV": {
                    "isE": true
                }
            }
        ],
        "grouping" : {
            
        }
    },
    "ht": {
        "tb": {
            "ast": "Asistans",
            "srch": "Rechèch",
            "mB": "Bot mwen",
            "trnspt": "Transkripsyon"
        },
        "sg": {
            "sA": {
                "lbl": {
                    "ans": "Repons",
                    "wP": "Paj Web",
                    "files": "Fichye"
                }
            },
            "faq": {
                "lbl": {
                    "faq": "Kesyon"
                }
            },
            "dT": {
                "lbl": {
                    "dTN": "Travay Dyalo",
                    "tmnt": "Fini",
                    "tmntCfm": "Fini Travay Dyalo",
                    "tmntBtn": "Wi, Fini",
                    "scVsbty": 50
                },
                "tL": {
                    "isE": true,
                    "st": {
                        "isE": true,
                        "msg": "Dyalo {{Task}} te kòmanse"
                    },
                    "end": {
                        "isE": true,
                        "msg": "Dyalo {{Task}} fini"
                    }
                },
                "mT": {
                    "isE": true,
                    "ask": {
                        "isE": true,
                        "msg": "Mande Kliyan"
                    },
                    "tell": {
                        "isE": true,
                        "msg": "Di Kliyan"
                    }
                }
            }
        },
        "lout": {
            "pos": "anba",
            "dfTb": "ast",
            "ord": [
                {
                    "ast": {
                        "isE": true
                    }
                },
                {
                    "srch": {
                        "isE": true
                    }
                },
                {
                    "mB": {
                        "isE": true
                    }
                },
                {
                    "trnspt": {
                        "isE": true
                    }
                }
            ]
        },
        "act": [
            {
                "smt": {
                    "isE": true
                }
            },
            {
                "rst": {
                    "isE": true
                }
            },
            {
                "lV": {
                    "isE": true
                }
            }
        ],
        "grouping" : {
            
        }
    },
    "tl": {
        "tb": {
            "ast": "Tulong sa Bahay",
            "srch": "Maghanap",
            "mB": "Aking Bot",
            "trnspt": "Transkripsyon"
        },
        "sg": {
            "sA": {
                "lbl": {
                    "ans": "Mga Sagot",
                    "wP": "Mga Web Page",
                    "files": "Mga File"
                }
            },
            "faq": {
                "lbl": {
                    "faq": "Mga Tanong"
                }
            },
            "dT": {
                "lbl": {
                    "dTN": "Dialog Task",
                    "tmnt": "Tigil",
                    "tmntCfm": "Tigilan ang Dialog Task",
                    "tmntBtn": "Oo, Tigilin",
                    "scVsbty": 50
                },
                "tL": {
                    "isE": true,
                    "st": {
                        "isE": true,
                        "msg": "Nagsimula ang Dialog {{Task}}"
                    },
                    "end": {
                        "isE": true,
                        "msg": "Nagtapos ang Dialog {{Task}}"
                    }
                },
                "mT": {
                    "isE": true,
                    "ask": {
                        "isE": true,
                        "msg": "Tanungin ang Customer"
                    },
                    "tell": {
                        "isE": true,
                        "msg": "Sabihin sa Customer"
                    }
                }
            }
        },
        "lout": {
            "pos": "ibaba",
            "dfTb": "ast",
            "ord": [
                {
                    "ast": {
                        "isE": true
                    }
                },
                {
                    "srch": {
                        "isE": true
                    }
                },
                {
                    "mB": {
                        "isE": true
                    }
                },
                {
                    "trnspt": {
                        "isE": true
                    }
                }
            ]
        },
        "act": [
            {
                "smt": {
                    "isE": true
                }
            },
            {
                "rst": {
                    "isE": true
                }
            },
            {
                "lV": {
                    "isE": true
                }
            }
        ],
        "grouping" : {
            
        }
    },
    "fi": {
        "tb": {
            "ast": "Apu Kotiin",
            "srch": "Haku",
            "mB": "Botteni",
            "trnspt": "Transkriptio"
        },
        "sg": {
            "sA": {
                "lbl": {
                    "ans": "Vastaukset",
                    "wP": "Verkkosivut",
                    "files": "Tiedostot"
                }
            },
            "faq": {
                "lbl": {
                    "faq": "UKK"
                }
            },
            "dT": {
                "lbl": {
                    "dTN": "Dialogitehtävä",
                    "tmnt": "Lopeta",
                    "tmntCfm": "Lopeta Dialogitehtävä",
                    "tmntBtn": "Kyllä, Lopeta",
                    "scVsbty": 50
                },
                "tL": {
                    "isE": true,
                    "st": {
                        "isE": true,
                        "msg": "Dialogi {{Task}} aloitettu"
                    },
                    "end": {
                        "isE": true,
                        "msg": "Dialogi {{Task}} päättynyt"
                    }
                },
                "mT": {
                    "isE": true,
                    "ask": {
                        "isE": true,
                        "msg": "Kysy Asiakkaalta"
                    },
                    "tell": {
                        "isE": true,
                        "msg": "Kerro Asiakkaalle"
                    }
                }
            }
        },
        "lout": {
            "pos": "alhaalla",
            "dfTb": "ast",
            "ord": [
                {
                    "ast": {
                        "isE": true
                    }
                },
                {
                    "srch": {
                        "isE": true
                    }
                },
                {
                    "mB": {
                        "isE": true
                    }
                },
                {
                    "trnspt": {
                        "isE": true
                    }
                }
            ]
        },
        "act": [
            {
                "smt": {
                    "isE": true
                }
            },
            {
                "rst": {
                    "isE": true
                }
            },
            {
                "lV": {
                    "isE": true
                }
            }
        ],
        "grouping" : {
            
        }
    },
    "uk": {
        "tb": {
            "ast": "Допомога вдома",
            "srch": "Пошук",
            "mB": "Мій Бот",
            "trnspt": "Транскрипція"
        },
        "sg": {
            "sA": {
                "lbl": {
                    "ans": "Відповіді",
                    "wP": "Веб-сторінки",
                    "files": "Файли"
                }
            },
            "faq": {
                "lbl": {
                    "faq": "Питання"
                }
            },
            "dT": {
                "lbl": {
                    "dTN": "Діалогове завдання",
                    "tmnt": "Припинити",
                    "tmntCfm": "Припинити діалогове завдання",
                    "tmntBtn": "Так, припинити",
                    "scVsbty": 50
                },
                "tL": {
                    "isE": true,
                    "st": {
                        "isE": true,
                        "msg": "Діалог {{Task}} розпочато"
                    },
                    "end": {
                        "isE": true,
                        "msg": "Діалог {{Task}} закінчено"
                    }
                },
                "mT": {
                    "isE": true,
                    "ask": {
                        "isE": true,
                        "msg": "Запитайте клієнта"
                    },
                    "tell": {
                        "isE": true,
                        "msg": "Скажіть клієнту"
                    }
                }
            }
        },
        "lout": {
            "pos": "внизу",
            "dfTb": "ast",
            "ord": [
                {
                    "ast": {
                        "isE": true
                    }
                },
                {
                    "srch": {
                        "isE": true
                    }
                },
                {
                    "mB": {
                        "isE": true
                    }
                },
                {
                    "trnspt": {
                        "isE": true
                    }
                }
            ]
        },
        "act": [
            {
                "smt": {
                    "isE": true
                }
            },
            {
                "rst": {
                    "isE": true
                }
            },
            {
                "lV": {
                    "isE": true
                }
            }
        ],
        "grouping" : {
            
        }
    },
    "sv": {
        "tb": {
            "ast": "Hjälp Hemma",
            "srch": "Sök",
            "mB": "Min Bot",
            "trnspt": "Transkription"
        },
        "sg": {
            "sA": {
                "lbl": {
                    "ans": "Svar",
                    "wP": "Webbsidor",
                    "files": "Filer"
                }
            },
            "faq": {
                "lbl": {
                    "faq": "FAQ"
                }
            },
            "dT": {
                "lbl": {
                    "dTN": "Dialoguppgift",
                    "tmnt": "Avsluta",
                    "tmntCfm": "Avsluta Dialoguppgift",
                    "tmntBtn": "Ja, Avsluta",
                    "scVsbty": 50
                },
                "tL": {
                    "isE": true,
                    "st": {
                        "isE": true,
                        "msg": "Dialog {{Task}} har startat"
                    },
                    "end": {
                        "isE": true,
                        "msg": "Dialog {{Task}} har avslutats"
                    }
                },
                "mT": {
                    "isE": true,
                    "ask": {
                        "isE": true,
                        "msg": "Fråga Kunden"
                    },
                    "tell": {
                        "isE": true,
                        "msg": "Berätta för Kunden"
                    }
                }
            }
        },
        "lout": {
            "pos": "nedan",
            "dfTb": "ast",
            "ord": [
                {
                    "ast": {
                        "isE": true
                    }
                },
                {
                    "srch": {
                        "isE": true
                    }
                },
                {
                    "mB": {
                        "isE": true
                    }
                },
                {
                    "trnspt": {
                        "isE": true
                    }
                }
            ]
        },
        "act": [
            {
                "smt": {
                    "isE": true
                }
            },
            {
                "rst": {
                    "isE": true
                }
            },
            {
                "lV": {
                    "isE": true
                }
            }
        ],
        "grouping" : {
            
        }
    },
    "ca": {
        "tb": {
            "ast": "Assistència a Casa",
            "srch": "Cerca",
            "mB": "El meu Bot",
            "trnspt": "Transcripció"
        },
        "sg": {
            "sA": {
                "lbl": {
                    "ans": "Respostes",
                    "wP": "Pàgines Web",
                    "files": "Fitxers"
                }
            },
            "faq": {
                "lbl": {
                    "faq": "Preguntes"
                }
            },
            "dT": {
                "lbl": {
                    "dTN": "Tasques de Diàleg",
                    "tmnt": "Terminar",
                    "tmntCfm": "Terminar la Tasca de Diàleg",
                    "tmntBtn": "Sí, Termina",
                    "scVsbty": 50
                },
                "tL": {
                    "isE": true,
                    "st": {
                        "isE": true,
                        "msg": "Diàleg {{Task}} iniciat"
                    },
                    "end": {
                        "isE": true,
                        "msg": "Diàleg {{Task}} finalitzat"
                    }
                },
                "mT": {
                    "isE": true,
                    "ask": {
                        "isE": true,
                        "msg": "Preguntar al Client"
                    },
                    "tell": {
                        "isE": true,
                        "msg": "Dir al Client"
                    }
                }
            }
        },
        "lout": {
            "pos": "baix",
            "dfTb": "ast",
            "ord": [
                {
                    "ast": {
                        "isE": true
                    }
                },
                {
                    "srch": {
                        "isE": true
                    }
                },
                {
                    "mB": {
                        "isE": true
                    }
                },
                {
                    "trnspt": {
                        "isE": true
                    }
                }
            ]
        },
        "act": [
            {
                "smt": {
                    "isE": true
                }
            },
            {
                "rst": {
                    "isE": true
                }
            },
            {
                "lV": {
                    "isE": true
                }
            }
        ],
        "grouping" : {
            
        }
    },
    "az": {
        "tb": {
            "ast": "Evdə Kömək",
            "srch": "Axtar",
            "mB": "Mənim Botum",
            "trnspt": "Transkript"
        },
        "sg": {
            "sA": {
                "lbl": {
                    "ans": "Cavablar",
                    "wP": "Veb Səhifələr",
                    "files": "Fayllar"
                }
            },
            "faq": {
                "lbl": {
                    "faq": "Tez-tez verilən suallar"
                }
            },
            "dT": {
                "lbl": {
                    "dTN": "Dialoq Tapşırığı",
                    "tmnt": "Bitir",
                    "tmntCfm": "Dialoq Tapşırığını Bitir",
                    "tmntBtn": "Bəli, Bitir",
                    "scVsbty": 50
                },
                "tL": {
                    "isE": true,
                    "st": {
                        "isE": true,
                        "msg": "Dialoq {{Task}} başladı"
                    },
                    "end": {
                        "isE": true,
                        "msg": "Dialoq {{Task}} başa çatdı"
                    }
                },
                "mT": {
                    "isE": true,
                    "ask": {
                        "isE": true,
                        "msg": "Müştəridən Soruş"
                    },
                    "tell": {
                        "isE": true,
                        "msg": "Müştəriyə De"
                    }
                }
            }
        },
        "lout": {
            "pos": "aşağıda",
            "dfTb": "ast",
            "ord": [
                {
                    "ast": {
                        "isE": true
                    }
                },
                {
                    "srch": {
                        "isE": true
                    }
                },
                {
                    "mB": {
                        "isE": true
                    }
                },
                {
                    "trnspt": {
                        "isE": true
                    }
                }
            ]
        },
        "act": [
            {
                "smt": {
                    "isE": true
                }
            },
            {
                "rst": {
                    "isE": true
                }
            },
            {
                "lV": {
                    "isE": true
                }
            }
        ],
        "grouping" : {
            
        }
    },
    "da": {
        "tb": {
            "ast": "Hjælp Hjemme",
            "srch": "Søg",
            "mB": "Min Bot",
            "trnspt": "Transkription"
        },
        "sg": {
            "sA": {
                "lbl": {
                    "ans": "Svar",
                    "wP": "Websider",
                    "files": "Filer"
                }
            },
            "faq": {
                "lbl": {
                    "faq": "FAQ"
                }
            },
            "dT": {
                "lbl": {
                    "dTN": "Dialogopgave",
                    "tmnt": "Afslut",
                    "tmntCfm": "Afslut Dialogopgaven",
                    "tmntBtn": "Ja, Afslut",
                    "scVsbty": 50
                },
                "tL": {
                    "isE": true,
                    "st": {
                        "isE": true,
                        "msg": "Dialog {{Task}} startet"
                    },
                    "end": {
                        "isE": true,
                        "msg": "Dialog {{Task}} afsluttet"
                    }
                },
                "mT": {
                    "isE": true,
                    "ask": {
                        "isE": true,
                        "msg": "Spørg Kunden"
                    },
                    "tell": {
                        "isE": true,
                        "msg": "Fortæl Kunden"
                    }
                }
            }
        },
        "lout": {
            "pos": "nederst",
            "dfTb": "ast",
            "ord": [
                {
                    "ast": {
                        "isE": true
                    }
                },
                {
                    "srch": {
                        "isE": true
                    }
                },
                {
                    "mB": {
                        "isE": true
                    }
                },
                {
                    "trnspt": {
                        "isE": true
                    }
                }
            ]
        },
        "act": [
            {
                "smt": {
                    "isE": true
                }
            },
            {
                "rst": {
                    "isE": true
                }
            },
            {
                "lV": {
                    "isE": true
                }
            }
        ],
        "grouping" : {
            
        }
    },
    "ms": {
        "tb": {
            "ast": "Bantuan di Rumah",
            "srch": "Carian",
            "mB": "Bot Saya",
            "trnspt": "Transkripsi"
        },
        "sg": {
            "sA": {
                "lbl": {
                    "ans": "Jawapan",
                    "wP": "Laman Web",
                    "files": "Fail"
                }
            },
            "faq": {
                "lbl": {
                    "faq": "Soalan"
                }
            },
            "dT": {
                "lbl": {
                    "dTN": "Tugas Dialog",
                    "tmnt": "Hentikan",
                    "tmntCfm": "Hentikan Tugas Dialog",
                    "tmntBtn": "Ya, Hentikan",
                    "scVsbty": 50
                },
                "tL": {
                    "isE": true,
                    "st": {
                        "isE": true,
                        "msg": "Dialog {{Task}} bermula"
                    },
                    "end": {
                        "isE": true,
                        "msg": "Dialog {{Task}} tamat"
                    }
                },
                "mT": {
                    "isE": true,
                    "ask": {
                        "isE": true,
                        "msg": "Tanya Pelanggan"
                    },
                    "tell": {
                        "isE": true,
                        "msg": "Beritahu Pelanggan"
                    }
                }
            }
        },
        "lout": {
            "pos": "bawah",
            "dfTb": "ast",
            "ord": [
                {
                    "ast": {
                        "isE": true
                    }
                },
                {
                    "srch": {
                        "isE": true
                    }
                },
                {
                    "mB": {
                        "isE": true
                    }
                },
                {
                    "trnspt": {
                        "isE": true
                    }
                }
            ]
        },
        "act": [
            {
                "smt": {
                    "isE": true
                }
            },
            {
                "rst": {
                    "isE": true
                }
            },
            {
                "lV": {
                    "isE": true
                }
            }
        ],
        "grouping" : {
            
        }
    },
    "my": {
        "tb": {
            "ast": "အိမ်အတွက် အကူအညီ",
            "srch": "ရှာဖွေပါ",
            "mB": "ကျွန်ုပ်၏ ဘော့",
            "trnspt": "စာတိုက်စာ"
        },
        "sg": {
            "sA": {
                "lbl": {
                    "ans": "ဖြေကြောင်းများ",
                    "wP": "ဝဘ်စာမျက်နှာများ",
                    "files": "ဖိုင်များ"
                }
            },
            "faq": {
                "lbl": {
                    "faq": "မေးခွန်းများ"
                }
            },
            "dT": {
                "lbl": {
                    "dTN": "စကားဝိုင်းအလုပ်",
                    "tmnt": "ပြီး",
                    "tmntCfm": "စကားဝိုင်းအလုပ်ကို ပျက်သိမ်းပါ",
                    "tmntBtn": "ဟုတ်၊ ပျက်သိမ်းပါ",
                    "scVsbty": 50
                },
                "tL": {
                    "isE": true,
                    "st": {
                        "isE": true,
                        "msg": "စကားဝိုင်း {{Task}} စတင်ခဲ့သည်"
                    },
                    "end": {
                        "isE": true,
                        "msg": "စကားဝိုင်း {{Task}} အဆုံးသတ်ခဲ့သည်"
                    }
                },
                "mT": {
                    "isE": true,
                    "ask": {
                        "isE": true,
                        "msg": "ဖောက်သည်ကို မေးပါ"
                    },
                    "tell": {
                        "isE": true,
                        "msg": "ဖောက်သည်ကို ပြောပါ"
                    }
                }
            }
        },
        "lout": {
            "pos": "အောက်",
            "dfTb": "ast",
            "ord": [
                {
                    "ast": {
                        "isE": true
                    }
                },
                {
                    "srch": {
                        "isE": true
                    }
                },
                {
                    "mB": {
                        "isE": true
                    }
                },
                {
                    "trnspt": {
                        "isE": true
                    }
                }
            ]
        },
        "act": [
            {
                "smt": {
                    "isE": true
                }
            },
            {
                "rst": {
                    "isE": true
                }
            },
            {
                "lV": {
                    "isE": true
                }
            }
        ],
        "grouping" : {
            
        }
    },
    "th": {
        "tb": {
            "ast": "ช่วยเหลือที่บ้าน",
            "srch": "ค้นหา",
            "mB": "บอทของฉัน",
            "trnspt": "ถอดความ"
        },
        "sg": {
            "sA": {
                "lbl": {
                    "ans": "คำตอบ",
                    "wP": "หน้าเว็บ",
                    "files": "ไฟล์"
                }
            },
            "faq": {
                "lbl": {
                    "faq": "คำถาม"
                }
            },
            "dT": {
                "lbl": {
                    "dTN": "งานสนทนา",
                    "tmnt": "หยุด",
                    "tmntCfm": "หยุดงานสนทนา",
                    "tmntBtn": "ใช่ หยุด",
                    "scVsbty": 50
                },
                "tL": {
                    "isE": true,
                    "st": {
                        "isE": true,
                        "msg": "งานสนทนา {{Task}} เริ่มต้นแล้ว"
                    },
                    "end": {
                        "isE": true,
                        "msg": "งานสนทนา {{Task}} เสร็จสิ้น"
                    }
                },
                "mT": {
                    "isE": true,
                    "ask": {
                        "isE": true,
                        "msg": "ถามลูกค้า"
                    },
                    "tell": {
                        "isE": true,
                        "msg": "บอกลูกค้า"
                    }
                }
            }
        },
        "lout": {
            "pos": "ด้านล่าง",
            "dfTb": "ast",
            "ord": [
                {
                    "ast": {
                        "isE": true
                    }
                },
                {
                    "srch": {
                        "isE": true
                    }
                },
                {
                    "mB": {
                        "isE": true
                    }
                },
                {
                    "trnspt": {
                        "isE": true
                    }
                }
            ]
        },
        "act": [
            {
                "smt": {
                    "isE": true
                }
            },
            {
                "rst": {
                    "isE": true
                }
            },
            {
                "lV": {
                    "isE": true
                }
            }
        ],
        "grouping" : {
            
        }
    },
    "pt_pt": {
        "tb": {
            "ast": "Ajuda em Casa",
            "srch": "Pesquisar",
            "mB": "O Meu Bot",
            "trnspt": "Transcrição"
        },
        "sg": {
            "sA": {
                "lbl": {
                    "ans": "Respostas",
                    "wP": "Páginas Web",
                    "files": "Ficheiros"
                }
            },
            "faq": {
                "lbl": {
                    "faq": "FAQ"
                }
            },
            "dT": {
                "lbl": {
                    "dTN": "Tarefa de Diálogo",
                    "tmnt": "Terminar",
                    "tmntCfm": "Terminar Tarefa de Diálogo",
                    "tmntBtn": "Sim, Terminar",
                    "scVsbty": 50
                },
                "tL": {
                    "isE": true,
                    "st": {
                        "isE": true,
                        "msg": "Diálogo {{Task}} iniciado"
                    },
                    "end": {
                        "isE": true,
                        "msg": "Diálogo {{Task}} terminado"
                    }
                },
                "mT": {
                    "isE": true,
                    "ask": {
                        "isE": true,
                        "msg": "Perguntar ao Cliente"
                    },
                    "tell": {
                        "isE": true,
                        "msg": "Dizer ao Cliente"
                    }
                }
            }
        },
        "lout": {
            "pos": "em baixo",
            "dfTb": "ast",
            "ord": [
                {
                    "ast": {
                        "isE": true
                    }
                },
                {
                    "srch": {
                        "isE": true
                    }
                },
                {
                    "mB": {
                        "isE": true
                    }
                },
                {
                    "trnspt": {
                        "isE": true
                    }
                }
            ]
        },
        "act": [
            {
                "smt": {
                    "isE": true
                }
            },
            {
                "rst": {
                    "isE": true
                }
            },
            {
                "lV": {
                    "isE": true
                }
            }
        ],
        "grouping" : {
            
        }
    }
}

